import { render, staticRenderFns } from "./cartridge-model-add.vue?vue&type=template&id=37b6ec32&"
import script from "./cartridge-model-add.vue?vue&type=script&lang=js&"
export * from "./cartridge-model-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37b6ec32')) {
      api.createRecord('37b6ec32', component.options)
    } else {
      api.reload('37b6ec32', component.options)
    }
    module.hot.accept("./cartridge-model-add.vue?vue&type=template&id=37b6ec32&", function () {
      api.rerender('37b6ec32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/device-manage/cartridge-model/cartridge-model-add.vue"
export default component.exports